var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/digitaltaxdownload/viewmodels/index',["require", "exports", "common/viewmodelbase"], function (require, exports, Common) {
    "use strict";
    var DTDownloadViewModel = (function (_super) {
        __extends(DTDownloadViewModel, _super);
        //public breadCrumb: Portal.ModuleBreadCrumbItemHolder = new Portal.ModuleBreadCrumbItemHolder();
        function DTDownloadViewModel() {
            _super.call(this);
            this.title = "Digital Tax";
            //ko.track(this, [""]); 
        }
        return DTDownloadViewModel;
    }(Common.ViewModelBase));
    var instance = new DTDownloadViewModel();
    return instance;
});

